import { mutator } from "satcheljs";
import { shiftRequestStore } from "../";
import updateUnreadRequestsCountInStore from "../actions/updateUnreadRequestsCountInStore";

/**
 * Update unread requests count in shift request store
 */
export default mutator(updateUnreadRequestsCountInStore, ({ unreadRequestsCount }) => {
    shiftRequestStore().unreadRequestsCount = unreadRequestsCount;
});